import React, { useEffect } from 'react';
import './bvi.scss';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import { BviIcon } from '../Icons';

const Bvi = ({
  className,
}) => {
  useEffect(() => {
    import('../assets/js/bvi/bvi-config')
      .then(() => import('../assets/js/bvi/bvi'))
      .then(() => import('../assets/js/bvi/bvi-panel'));
  }, []);

  return (
    <div className={classNames('bvi-button text-center search-form-mobile', className)}>
      <a href="#" className="bvi-panel-open bvi-panel-open-menu">
        <span className="bvi-eye bvi-color">
          <BviIcon />
        </span>
      </a>
    </div>
  );
};
Bvi.propTypes = {
  className: PropTypes.string,
};

Bvi.defaultProps = {
  className: undefined,
};

export default Bvi;
